import { NavLink, Outlet } from 'react-router';

const MENU_ITEMS = [
  { to: '/settings/users', label: 'Users' },
];

export default function Settings() {
  return (
    <div className="settings-layout">
      <nav className="settings-menu" aria-label="Settings">
        <ul>
          {MENU_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to}>{item.label}</NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <section className="settings-content">
        <Outlet />
      </section>
    </div>
  );
}
